<div class="d-flex align-items-center heigth-100 width-100">
    <form [formGroup]="form" class="width-100">
        <mat-form-field class="search-text-size general-search-input mat-focused" appearance="outline">
            <mat-icon class="color-omicron"
                matPrefix>search</mat-icon>
            <input (focus)="hasFocus = true" (blur)="hasFocus = false" type="text" placeholder="Buscador general, por código y descripción" matInput formControlName="search" [matAutocomplete]="auto"
                (keydown.enter)="searchFilter()">
            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="searchFilter()">
                <mat-optgroup label="Búsquedas recientes" class="font-omicron-medium">
                    <mat-option *ngFor="let option of filteredOptions | async" [value]="option"
                        class="search-text-size pl-3">
                        {{ option }}
                    </mat-option>
                </mat-optgroup>
            </mat-autocomplete>
            <mat-icon class="color-omicron" *ngIf="form.controls.search.value" matSuffix
                (click)="form.controls.search.setValue('')">close</mat-icon>
        </mat-form-field>
    </form>
</div>